import { generatePath, useNavigate } from 'react-router-dom';

import { ReportsDataGridFields } from '@/components/modules/Reports/ReportsList/components/ReportsDataGridFields/ReportsDataGridFields';
import { useReportsList } from '@/components/modules/Reports/ReportsList/hooks/useReportsList';
import { ReportsListRowProps } from '@/components/modules/Reports/ReportsList/types/ReportsListRowProps';
import { MultiFilteredList } from '@/components/shared/components/MultiFilteredList';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { useOperationsContext } from '@/contexts/OperationsContext/OperationsContext';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const ReportsList = () => {
  const { fetchReportsList } = useReportsList();
  const navigate = useNavigate();
  const {
    state: { lastViewedReportId },
    actions: { updateOperationsContext },
  } = useOperationsContext();

  const tableColumns = ReportsDataGridFields();

  return (
    <MultiFilteredList
      fetchList={fetchReportsList}
      dataGridFields={tableColumns}
      onRowClick={(selectedRow: ReportsListRowProps) => {
        updateOperationsContext({ lastViewedReportId: selectedRow.row.id, selectedReport: selectedRow.row });
        navigate(
          generatePath(DYNAMIC_PAGE_PATHS.REPORT, {
            reportId: selectedRow.row.id,
          }),
        );
      }}
      getRowClassName={(params) => {
        if (params.row.id === lastViewedReportId) return 'last-viewed-application';
        else return '';
      }}
      dateFilterProps={{
        dateField: 'report_date',
      }}
      defaultOrderBy={'report_date'}
      showSearch={false}
      disableSelectionOnClick
    />
  );
};

export const ReportsListModule = withPermissionsModule(ReportsList);
